export default __webpack_public_path__ + "static/media/ChakraPetch-Bold.aa78c3ef.woff";